const AddEmailConfirmation = (props) => {
    const { email, aliasesEmail, url } = props
    return `
        <!DOCTYPE html>
        <html>
        <head>
            <meta charset="UTF-8" />
            <meta name="viewport" content="width=device-width, initial-scale=1.0" />
            <title>DMail Verification</title>
            <style>
            body {
                margin: 0;
                font-family: 'Segoe UI', sans-serif;
                background-color: #f5f7fa;
                color: #333;
                line-height: 1.6;
            }
            .email-container {
                max-width: 700px;
                margin: 20px auto;
                background: #ffffff;
                padding: 30px;
                border-radius: 10px;
                box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
            }
            a {
                color: #0b6de0;
                word-break: break-word;
            }
            .button {
                display: inline-block;
                margin-top: 20px;
                padding: 10px 20px;
                background: linear-gradient(97deg, #18F06E -7.9%, #0B6DE0 117.63%);
                color: white !important;
                text-decoration: none;
                border-radius: 6px;
                font-weight: bold;
            }
            @media (max-width: 600px) {
                .email-container {
                padding: 20px;
                }
            }
            </style>
        </head>
        <body>
            <div class="email-container">
            <p>You have requested to add <strong>${aliasesEmail}</strong> to your DMail account.</p>

            <p>
                Before you can send mail from <strong>${aliasesEmail}</strong> using your DMail account
                (<a href="mailto:${email}">${email}</a>), please click the link below to confirm your request:
            </p>

            <p>If the link doesn't work, copy and paste this URL into your browser:</p>
            <a href=${url}>${url}</a>
            <br/>
            <p>Thanks for using DMail.</p>
            <p>Sincerely,<br>The DMail Team</p>

            <hr style="margin: 30px 0; border: none; border-top: 1px solid #ddd;" />

            <p>
                If you did not make this request or don’t want to add this email to your DMail account, no further action is required.
            </p>

            <p>
                <strong>${email}</strong> cannot send messages using your email address unless you confirm. If this was a mistake,
                you can cancel it using the link below:
            </p>

            <a href=${url}>Cancel Verification</a>

            <p style="font-size: 12px; color: #999;">
                Please don’t reply to this message. If you need help, log in to your account and click ‘Help’ at the top, then click
                ‘Contact us’.
            </p>
            </div>
        </body>
        </html> 
    `
}

export default AddEmailConfirmation;